import HyperDX from "@hyperdx/browser";
import type { ReactNode } from "react";
import { Component } from "react";

type Props = {
  children?: ReactNode;
};

class ErrorBoundary extends Component<Props> {
  state: { error: null | Error };

  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error: error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    try {
      HyperDX.recordException(error, {
        name: "React Error Boundary",
        componentStack: errorInfo.componentStack ?? undefined,
      });
    } catch (err) {
      console.warn("Error in HyperDX error reporting:", err);
    }

    // Also log to console for development
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return <p>{this.state.error.message}</p>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
